import React from 'react';
import { FaLine, FaEnvelope, FaPhoneAlt } from "react-icons/fa";

import ScrollReveal from '../components/ScrollReveal';

import ChefCat from '../assets/contact_images/WhiteCat.png';

function Contact() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-yellow-50 via-white to-orange-50">
      {/* Hero Section */}
      <section className="relative pt-28 pb-8 md:pt-36 md:pb-12 overflow-hidden">
        {/* Animated Background Elements */}
        <div className="absolute top-10 left-10 w-72 h-72 bg-[#FED700]/20 rounded-full mix-blend-multiply filter blur-3xl opacity-40 animate-pulse"></div>
        <div className="absolute bottom-10 right-10 w-72 h-72 bg-[#F4900C]/20 rounded-full mix-blend-multiply filter blur-3xl opacity-40 animate-pulse delay-1000"></div>

        <div className="container-custom relative z-10">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              Contact <span className="text-[#F4900C]">Us</span>
            </h1>

            <p className="text-lg md:text-xl text-gray-600 leading-relaxed max-w-2xl mx-auto">
              Questions about our board games, workshops, or partnerships?
              We'd love to hear from you.
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="pb-16 md:pb-24">
        <div className="container-custom">
          <div className="grid lg:grid-cols-2 gap-12 max-w-6xl mx-auto">

            {/* Left Column - Contact Information */}
            <ScrollReveal>
            <div>
              <div className="mb-10">
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                  Reach Out <span className="text-[#F4900C]">Directly</span>
                </h2>
                <p className="text-gray-600 text-lg">
                  Pick whichever channel works best for you — we're quick to reply.
                </p>
              </div>

              {/* Contact Cards */}
              <div className="space-y-6">

                {/* Line Card */}
                <div
                  className="group block bg-white rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-500 overflow-hidden border border-yellow-100 hover:border-[#F4900C]/30 hover:-translate-y-1"
                >
                  <div className="p-6">
                    <div className="flex items-start gap-5">
                      <div className="flex-shrink-0">
                        <div className="w-14 h-14 bg-gradient-to-br from-[#FED700] to-[#F4900C] rounded-xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                          <FaLine className="text-white text-3xl" />
                        </div>
                      </div>
                      <div className="flex-grow">
                        <h3 className="text-xl font-bold text-gray-900 mb-2">Line</h3>
                        <p className="text-gray-700 group-hover:text-[#F4900C] transition-colors">
                          @WealthyCats (Placeholder)
                        </p>
                        <p className="text-gray-500 text-sm">For general inquiries</p>
                      </div>
                      <div className="text-[#F4900C] opacity-0 group-hover:opacity-100 transition-all duration-300 transform group-hover:translate-x-1">
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Email Card */}
                <a
                  href="mailto:win@hacademyasia.com"
                  className="group block bg-white rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-500 overflow-hidden border border-yellow-100 hover:border-[#F4900C]/30 hover:-translate-y-1"
                >
                  <div className="p-6">
                    <div className="flex items-start gap-5">
                      <div className="flex-shrink-0">
                        <div className="w-14 h-14 bg-gradient-to-br from-[#FED700] to-[#F4900C] rounded-xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                          <FaEnvelope className="text-white text-2xl" />
                        </div>
                      </div>
                      <div className="flex-grow">
                        <h3 className="text-xl font-bold text-gray-900 mb-2">Email</h3>
                        <p className="text-gray-700 group-hover:text-[#F4900C] transition-colors">
                          win@hacademyasia.com
                        </p>
                        <p className="text-gray-500 text-sm">For general inquiries and partnerships</p>
                      </div>
                      <div className="text-[#F4900C] opacity-0 group-hover:opacity-100 transition-all duration-300 transform group-hover:translate-x-1">
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </a>

                {/* Phone Card */}
                <a
                  href="tel:+66994645592"
                  className="group block bg-white rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-500 overflow-hidden border border-yellow-100 hover:border-[#F4900C]/30 hover:-translate-y-1"
                >
                  <div className="p-6">
                    <div className="flex items-start gap-5">
                      <div className="flex-shrink-0">
                        <div className="w-14 h-14 bg-gradient-to-br from-[#FED700] to-[#F4900C] rounded-xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                          <FaPhoneAlt className="text-white text-2xl" />
                        </div>
                      </div>
                      <div className="flex-grow">
                        <h3 className="text-xl font-bold text-gray-900 mb-2">Call</h3>
                        <p className="text-gray-700 group-hover:text-[#F4900C] transition-colors">
                          +66 99-464-5592
                        </p>
                        <p className="text-gray-500 text-sm">Mon-Fri, 9 AM - 6 PM (GMT+7)</p>
                      </div>
                      <div className="text-[#F4900C] opacity-0 group-hover:opacity-100 transition-all duration-300 transform group-hover:translate-x-1">
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              {/* Social Media */}
              <div className="mt-12 pt-10 border-t border-yellow-200">
                <h3 className="text-2xl font-bold text-gray-900 mb-6">Follow Our Journey</h3>
                <p className="text-gray-600 mb-6">
                  Stay updated with our latest games, workshops, and financial literacy initiatives.
                </p>

                <div className="flex flex-col sm:flex-row gap-4">
                  <a
                    href="https://www.facebook.com/profile.php?id=61563842891479"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group flex items-center justify-center gap-3 bg-white rounded-xl shadow-lg hover:shadow-xl py-4 px-8 border-2 border-transparent hover:border-[#F4900C] transition-all duration-300"
                  >
                    <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center text-white">
                      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                      </svg>
                    </div>
                    <span className="font-semibold text-gray-900 group-hover:text-[#F4900C]">
                      Facebook Page
                    </span>
                  </a>

                  <a
                    href="https://www.youtube.com/@WealthyCats"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group flex items-center justify-center gap-3 bg-white rounded-xl shadow-lg hover:shadow-xl py-4 px-8 border-2 border-transparent hover:border-[#F4900C] transition-all duration-300"
                  >
                    <div className="w-8 h-8 bg-red-600 rounded-lg flex items-center justify-center text-white">
                      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                      </svg>
                    </div>
                    <span className="font-semibold text-gray-900 group-hover:text-[#F4900C]">
                      YouTube Channel
                    </span>
                  </a>
                </div>
              </div>
            </div>
            </ScrollReveal>

            {/* Right Column - Business & Orders */}
            <ScrollReveal delay={150}>
            <div className="mt-8 lg:mt-20 relative">
              {/* Chef cat peeking over the card */}
              <img
                src={ChefCat}
                alt="WealthyCats chef mascot"
                className="absolute -top-24 right-8 h-28 sm:h-32 w-auto z-0 rotate-3 animate-floaty"
                style={{ '--r': '3deg' }}
              />

              <div className="bg-gradient-to-br from-white to-yellow-50 rounded-3xl shadow-2xl overflow-hidden border-2 border-white relative z-10">
                {/* Decorative Corner */}
                <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-[#FED700] to-[#F4900C] transform translate-x-16 -translate-y-16 rotate-45 opacity-10"></div>

                <div className="relative z-10 p-8 md:p-10">
                  {/* Header */}
                  <div className="mb-8">

                    <h2 className="text-3xl font-bold text-gray-900 mb-4">
                      Business Inquiries & Orders
                    </h2>
                    <p className="text-gray-700 text-lg leading-relaxed">
                      For product purchases, school programs, or corporate workshops,
                      messaging us on Facebook ensures the fastest response.
                    </p>
                  </div>

                  {/* Features */}
                  <div className="space-y-5 mb-10">
                    <div className="flex items-start gap-4">
                      <div className="flex-shrink-0 w-8 h-8 bg-gradient-to-r from-[#FED700] to-[#F4900C] rounded-full flex items-center justify-center text-white">
                        ✓
                      </div>
                      <p className="text-gray-700">
                        <span className="font-semibold">Direct Communication:</span> Chat directly with our team
                      </p>
                    </div>
                    <div className="flex items-start gap-4">
                      <div className="flex-shrink-0 w-8 h-8 bg-gradient-to-r from-[#FED700] to-[#F4900C] rounded-full flex items-center justify-center text-white">
                        ✓
                      </div>
                      <p className="text-gray-700">
                        <span className="font-semibold">Quick Replies:</span> Typically respond within 24 hours
                      </p>
                    </div>
                  </div>

                  {/* Main CTA Button */}
                  <a
                    href="https://www.facebook.com/profile.php?id=61563842891479"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group block w-full bg-gradient-to-r from-[#FED700] to-[#F4900C] hover:from-[#FED700]/90 hover:to-[#F4900C]/90 text-gray-900 font-bold py-5 px-8 rounded-xl text-lg shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1"
                  >
                    <div className="flex items-center justify-center gap-4">
                      <div className="w-10 h-10 bg-white/90 rounded-xl flex items-center justify-center flex-shrink-0">
                        <svg className="w-6 h-6" fill="#F4900C" viewBox="0 0 24 24">
                          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                        </svg>
                      </div>
                      <div className="text-left">
                        <div className="font-bold text-lg">Contact Us on Facebook</div>
                        <div className="text-gray-800 text-sm font-normal">For orders, quotes, and workshops</div>
                      </div>
                      <div className="ml-auto opacity-0 group-hover:opacity-100 transition-all duration-300 transform group-hover:translate-x-1">
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                        </svg>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            </ScrollReveal>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
